import React from "react";
import CategoryPage from "./CategoryPage";

function NationalArticle({
  posts,
  publications
}) {

  return (
    <CategoryPage
      title="National"
      parentCategory="Articles"
      posts={posts}
      publications={publications}
    />
  );

}

export default NationalArticle;